//#region
import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import _, { get } from 'lodash';
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import ChartLayout from "../../components/_report/dashboard/ChartLayout";
import DashboardViewLayout from "../../components/_report/dashboard/DashboardViewLayout";
import SheetFilterView from "../../components/common/SheetFilterView";
import { findMeasureByNameAndDataSetId } from "../../config/services/measures";
import { getDashboarDetails, validateUserDashboard } from "../../config/services/publishDashboard";
import { useMeasureListContext } from "../../contexts/MeasureListContext";
import { savePDF } from "../../modifiedlibraries/pdfExport/react-to-pdf-converter";
import Loader from "../../pages/Loader";
import { applyFilterOnLinkedReports } from '../../utils/DashboardReusables';
import { ApplyBottomToastr, isMobileDevice } from "../../utils/Reusables";
import { DecryptData, EncryptData } from "../../utils/encryptDecrypt";
import getDataFromCube from "../../utils/getCubeData";
import { setLanguage, updateLanguage } from "../../utils/multiLangDashboardV2Data";
import PublishedDashboardSheets from "./PublishedDashboardSheet";
import { DashboardContextProvider, useDashboardContext } from "../dashboardView/DashboardView";
import DashboardViewSheet from "../dashboardView/DashboardViewSheet";
import DashboardSheetFilter from "../../components/common/DashboardSheetFilter";
import { useDispatch, useSelector } from "react-redux";
import { breadcrumbActions } from "../../redux/reducers/breadcrumb";
import BreadCrumb from "./BreadCrumb";
import Controls from "../../components/controls/Controls";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  headingButton: {
    display: 'flex',
    marginRight: '16px',
    width: '100px',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start'
    },
  },
  headingButtonWrap: {
    width: '90%',
    float: 'right',
    padding: '0 1rem',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#f45e29',
    },
    ['@media (max-width:1700px)']: {
      padding: '0 0.5rem',
      width: '95%',
      lineHeight: '16px',
      textAlign: 'center',
    },
    ['@media (max-width:1400px)']: {
      padding: '0.2rem 0.5rem',
      width: '100%',
      textAlign: 'center',
      lineHeight: '16px',
    },
    ['@media (max-width: 1199px)']: {
      float: 'left',
      maxWidth: '150px',
    }
  },
}));

function PublishedDashboard() {
  const isRedirect = new URLSearchParams(window.location.search).get('isRedirect') === 'true';
  const { dashboardState, currentSheet } = useDashboardContext();
  const dispatch = useDispatch()
  const breadcrumbList = useSelector(state => state.breadcrumb)
  const UrlParams = useParams();
  const location = useLocation()
  //console.log(breadcrumbList)
   
  const { dashboardName, dashboardDescription, dashboardUpdatedAt, isDeactivated, dashboardShareState, notificationBanner, pdfDownloadAllowed} = dashboardState;
  const embedRef = useRef();
  const classes = useStyles();
  const containerRef = useRef(null);
  const [exportProcessDialog, setExportProcessDialog] = useState(false);
  const { measureListByDataset, fetchMeasureListByDatasetId } = useMeasureListContext();
  const navigate = useNavigate()  
  const { search, state } = useLocation();
  const IsExportUrl = new URLSearchParams(search).get('export');
  const language = new URLSearchParams(search).get('lang');
  const isCommonDashboard = new URLSearchParams(search).get('isCommonDashboard');
  const isParentAppDashboard = new URLSearchParams(search).get('isParentAppDashboard');
  const isBreadcrumbDisabled = new URLSearchParams(search).get('isBreadcrumbDisabled');
  const ExportSheetIndex = new URLSearchParams(search).get('ExportSheetIndex');
  const [downloadPdf, setDownloadPdf] = useState(false);

  const handleDownloadPDF = () => {
    setDownloadPdf(true);
  }

  useLayoutEffect(() => {
    //console.log('useLayoutEffect', window.self != window.top, window.self, window.top, )
    const appType = localStorage.getItem('appType');
    if(appType) document.body.classList.add(`app-type-${appType}`);
    const isTouchDevice = isMobileDevice();
    if(isTouchDevice) document.body.classList.add(`touch-device`);
    if (window.self != window.top && embedRef.current) {
      embedRef.current.className = embedRef.current.className + " iframe-publish-dashboard";
      document.body.classList.add("iframe-reports");
    }
    if (state) updateLanguage(state);
    if (language) setLanguage(language);
  }, [language, state])


  useEffect(() => { // remove it with function to set breadcrumb from the fetchdashboard details
    //console.log(dashboardName)
    if (dashboardName) {
      document.title = dashboardName
      let inArr = breadcrumbList.list.find(obj => obj.key == location.pathname)
      if(!inArr){
        dispatch(breadcrumbActions.addElement({...location,key:location.pathname,title: dashboardState.dashboardName}))
      }
      try {
        window.top.postMessage({ msg: 'callReportBreadcrumb', data: dashboardName }, '*')
      } catch (e) {
        console.log('Breadcrumbs Error', e)
      }
    }
  }, [dashboardName])


  useEffect(() => {
    if (!isRedirect) {
      dispatch(breadcrumbActions.removeAll());
    }
  },[isRedirect])


  const exportPDFWithMethod = () => {
    let element = containerRef.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      margin: 40,
      fileName: `Report for ${new Date().getFullYear()}`
    }, () => {
      !downloadPdf && window.close();
      setDownloadPdf(false);
      setExportProcessDialog(false);
    });
  };

  const onUnload = (e,type) => {
    //console.log(e,type)
    dispatch(breadcrumbActions.removeElement({key:e.target.location.pathname}))
  }

  useEffect(() => {
    if (IsExportUrl === 'true' || IsExportUrl === true || downloadPdf === true) {
      setExportProcessDialog(true)
      setTimeout(() => exportPDFWithMethod(), [40000])
    }
    //console.log('Loaded')
    window.addEventListener("beforeunload",e =>  onUnload(e,'beforeunload'));
    window.addEventListener('popstate', e => onUnload(e,'popstate'));
    
    return () => {
      //console.log(location)
      dispatch(breadcrumbActions.removeElement({key:location.pathname}))
    }
  }, [downloadPdf]);

  if (isDeactivated) {
    return (<Box width="100%" height="100%" pl={3} pr={3} className="embedded publish-dashboard">
      <Typography variant="h5" noWrap> Dashboard is deactivated. Contact Admin. </Typography>
    </Box>)
  }

  if (dashboardState?.loading) {
    return (
      <Box width="100%" height="100vh" display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box
      width="100%"
      className={`embedded publish-dashboard ` + (isCommonDashboard || isParentAppDashboard ? `dashboard-common` : `dashboard-main`)}
      ref={embedRef}
    >
      {/* {!dashboardState || dashboardState?.loading ? <Loader /> : null} */}

      {/* <Box id="loader" sx={{ visibility: dashboardState?.loading ? 'visible' : 'hidden' }}><Loader /></Box> */}

      {isCommonDashboard === "true" ||
      isParentAppDashboard === "true" ||
      isBreadcrumbDisabled === "true" ? null : (
        <>
          <BreadCrumb />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Grid className="reports-embed-heading-section">
              <Grid container mb={2} className="report-new-header-container">
                <Grid
                  container
                  item
                  alignItems="start"
                  justifyContent="center"
                  direction="column"
                  className="reports-embed-header-content"
                  sm={12}
                  md={12}
                  lg={6}
                  order={{ lg: 1, md: 2, sm: 2, xs: 2 }}
                >
                  <Typography variant="h2" noWrap>
                    {dashboardName || ""}
                  </Typography>
                  <Typography variant="p">{dashboardDescription}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
              {pdfDownloadAllowed &&
              !IsExportUrl && !downloadPdf ? (
                <Box className={classes.headingButton} display="flex">
                  <Controls.Button
                    className={
                      classes.headingButtonWrap + " " + "report_form_ui_btn"
                    }
                    style={{padding:"20px 0px"}}
                    variant="contained"
                    onClick={handleDownloadPDF}
                    text={"Print PDF"}
                  />
                </Box>
              ) : null}
            </Box>
          </Box>

              {/* {sheetsAvailable?.length > 1 ? <PublishedDashboardSheets
          sheetsAvailable={sheetsAvailable}
          handleChangeSheet={handleChangeSheet}
          selectedSheetIndex={selectedSheetIndex}
          tabDesign={tabDesign}
        /> : null} */}
              {
                !dashboardState?.loading ? <DashboardViewSheet /> : null
              }
              {/* {
          // change it to use loader
          onMount ?
            <SheetFilterView
              valueList={valueList}
              selectedSheetIndex={selectedSheetIndex}
              sheetFilterList={sheetsAvailable[selectedSheetIndex]}
              applyFilterOnAllReport={applySheetFilterOnAllReport}
              isPublishedDashboardView={true}
              resetSingleFilter={resetSingleFilter}
              handleInitialRelevantValues={handleInitialRelevantValues}
              setValueList={setValueList}
              setLoader={setLoader}
            />
            : null
        } */}
              {
                !dashboardState?.loading ? <DashboardSheetFilter /> : null
              }
            </>
          )
      }

      <div ref={containerRef}>
        {
          !dashboardState?.loading && currentSheet?.reports.length ? (
            // <ChartLayout
            //   onLayoutChange={onLayoutChange}
            //   selectedReports={sheetsAvailable[selectedSheetIndex]?.reports}
            //   isPublishedDashboardView={true}
            //   publishedBodyRef={publishedBodyRef}
            //   renewCache={renewCache}
            //   isCommonDashboard={isCommonDashboard}
            //   isParentAppDashboard={isParentAppDashboard}
            //     measureListByDataset={measureListByDataset}
            //     fetchMeasureListByDatasetId={fetchMeasureListByDatasetId}
            // />
            <DashboardViewLayout
              selectedReports={currentSheet?.reports}
              measureListByDataset={measureListByDataset}
              fetchMeasureListByDatasetId={fetchMeasureListByDatasetId}
            />
          ) : null}
      </div>
      {
        exportProcessDialog ? <Dialog aria-labelledby="customized-dialog-title" open={exportProcessDialog}>
          <DialogTitle id="customized-dialog-title" >Export in Progress... </DialogTitle>
          <DialogContent dividers>
            <Typography > We're working to export the dashboard... <CircularProgress /> </Typography>
          </DialogContent>
        </Dialog> : null
      }
      {
        notificationBanner
          ? (<ApplyBottomToastr message="Reports get updated every 24 hours." />)
          : null
      }
    </Box >
  );

}

export default () => {
  const { measureListByDataset, fetchMeasureListByDatasetId, getMeasureList } = useMeasureListContext();
  async function getUrlFiltersForReport(report, filterParamsJson) {
    const promises = filterParamsJson?.map(async filter => {
      const [filterKey, value] = Object.entries(filter)?.[0];
      const measureList = measureListByDataset[report?.dataSetId] || await fetchMeasureListByDatasetId(report?.dataSetId);
      const measureExistInDataset = measureList?.find(measure => measure?.name === filterKey);

      // filter structure check and then push the filter in the same structure
      if (!measureExistInDataset) {
        return null;
      }
      const dataSetName = report?.measures?.[0]?.fieldName?.split('.')[0] || report?.dimensions?.[0]?.fieldName?.split('.')[0];

      return {
        member: `${dataSetName}.${filterKey}`,
        operator: 'equals',
        values: [value],
        urlFilter: true
      };
    });

    const results = await Promise.allSettled(promises);
    //console.log(results)
    const filters = results
      .filter(result => result.status === 'fulfilled')
      .map(result => result.value);

    return filters.filter(Boolean);
  }
  async function getUrlFilters(report) {
    //console.log('UrlFilters')
    const urlFilters = new URLSearchParams(window.location.search).get('filterParams');
    if (urlFilters) {
      const filterParamsJson = JSON.parse(decodeURIComponent(urlFilters));
      return await getUrlFiltersForReport(report, filterParamsJson);
    }
    return [];
  }
  return (
    <DashboardContextProvider isPublishedDashboardPage={true} getUrlFilters={getUrlFilters}>
      <PublishedDashboard />
    </DashboardContextProvider>
  )
}